var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Accordion from '@/components/Accordion.vue';
import Tooltip from 'src/components/Tooltip.vue';
import { listPiperunPipelines } from '@/clients/crm';
let PiperunOpportunityConfig = class PiperunOpportunityConfig extends Vue {
    constructor() {
        super(...arguments);
        this.selectedPipeline = null;
        this.selectedStage = null;
        this.pipelineList = [];
        this.stageList = [];
        this.piperunToken = '';
        this.waiting = false;
    }
    async mounted() {
        this.waiting = true;
        await this.listPipelinesInPiperun();
        this.setCachedValues();
        this.waiting = false;
    }
    changedSelectedPipeline(pipeline) {
        if (pipeline) {
            const pipe = this.pipelineList.find(p => p.id == pipeline.value);
            // allow_create_deal é um campo que indica se o deal pode ser criado iniciando nessa etapa, caso seja false
            // a api do piperun retorna um erro informando que essa etapa está bloqueada para a criação de oportunidades
            this.stageList = pipe.stages.filter(s => s.allow_create_deal);
        }
    }
    async listPipelinesInPiperun() {
        let currentPage = 1;
        let hasMorePages = true;
        while (hasMorePages) {
            try {
                const response = await listPiperunPipelines(currentPage);
                const data = response.data;
                this.pipelineList.push(...data.data);
                const totalPages = data.meta.total_pages;
                if (currentPage < totalPages) {
                    currentPage++;
                }
                else {
                    hasMorePages = false;
                }
            }
            catch (e) {
                hasMorePages = false;
            }
        }
    }
    setCachedValues() {
        if (!this.cachedValues)
            return;
        const pipe = this.pipelineList.find(v => v.id == this.cachedValues.pipeline);
        if (pipe) {
            this.selectedPipeline = {
                label: pipe.name,
                value: pipe.id,
            };
            const stage = pipe.stages.find(v => v.id == this.cachedValues.stage);
            if (stage) {
                this.selectedStage = {
                    label: stage.name,
                    value: stage.id,
                };
            }
        }
    }
    updateSelectStage() {
        if (this.selectedPipeline && this.selectedStage) {
            this.$emit('selectedPipelineAndStage', {
                pipeline: this.selectedPipeline.value,
                stage: this.selectedStage.value,
            });
        }
    }
};
__decorate([
    Prop({ default: () => null })
], PiperunOpportunityConfig.prototype, "cachedValues", void 0);
__decorate([
    Watch('selectedPipeline')
], PiperunOpportunityConfig.prototype, "changedSelectedPipeline", null);
PiperunOpportunityConfig = __decorate([
    Component({
        name: 'PiperunOpportunityConfig',
        components: {
            Accordion,
            Tooltip,
        },
    })
], PiperunOpportunityConfig);
export default PiperunOpportunityConfig;
